export const HidePreviewTypes = ['application/pdf'];
